module.exports = __webpack_public_path__ + "img/ico-introduction-3.4ec61640.svg";